import { render, staticRenderFns } from "./ResendGiftEmailDialog.vue?vue&type=template&id=384b419c&"
import script from "./ResendGiftEmailDialog.vue?vue&type=script&lang=ts&"
export * from "./ResendGiftEmailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports